<template>
    <component
        :is="display"
        :manufacturers="manufacturers"
        :tags="tags"
        :available-letters="availableLetters"
        :is-price-books="isPriceBooks"
    />
</template>

<script setup>
import {computed, markRaw} from "vue";
import { useUser } from "@/Composables";
import MarketingManufacturerContent from "../../../Themes/Marketing/Components/Modules/Manufacturers/ManufacturerContent.vue";
import SourcingManufacturerContent from "../../../Themes/Sourcing/Components/Modules/Manufacturers/ManufacturerContent.vue";
import _ from "lodash";

const props = defineProps(["manufacturers", "tags","isPriceBooks",'externalNav']);

const { settings } = useUser();
const display = computed(() =>
    settings.value.is_sourcing_mode
        ? markRaw(SourcingManufacturerContent)
        : markRaw(MarketingManufacturerContent)
);

const availableLetters = computed(() => {
    let firstLetters = [];
    props.manufacturers?.forEach((manufacturer) =>
        firstLetters.push(manufacturer.name?.charAt(0))
    );
    return _.uniq(firstLetters);
});
</script>
